"use client";

import { ArrowRight } from "lucide-react";
import Link from "next/link";
import React from "react";

import { WorkShowcase } from "@/modules/marketing/work/components/work-showcase";

export default function HomePortfolio() {
  return (
    <section id="portfolio" className="relative py-24 md:py-32 border-t border-white/[0.08] overflow-hidden bg-black text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
        {/* ─────────────────────────────────────────────────────────────
            EXACT REFERENCE LAYOUT:
            Portfolio
            AI Systems, Multi-Agent Swarms, Enterprise RAG...     (06) ALL PROJECTS →
            Full-Stack Architecture, and beyond
            ───────────────────────────────────────────────────────────── */}
        <div className="space-y-4 mb-6 md:mb-8">
          {/* Top Full-Width Display Title */}
          <h2 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold tracking-tight text-white leading-none">
            Portfolio
          </h2>

          {/* Subtitle Row with Right-Aligned CTA on the same row */}
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6">
            <p className="text-lg sm:text-2xl md:text-3xl text-slate-300 font-light tracking-tight max-w-3xl lg:max-w-4xl">
              AI Systems, Multi-Agent Swarms, Enterprise RAG, Full-Stack Architecture, and beyond
            </p>

            <div className="shrink-0 pt-1.5">
              <Link
                href="/work"
                className="inline-flex items-center gap-2 text-xs sm:text-sm md:text-base font-mono uppercase tracking-wider text-zinc-400 hover:text-white underline underline-offset-8 transition-colors group"
              >
                <span>(06) ALL PROJECTS</span>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </div>

        {/* 1px Full-Width Hairline Divider with Generous Spacing After */}
        <div className="w-full h-px bg-white/[0.12] mb-12 md:mb-16" />

        {/* Curated 4-Project Showcase without Filters */}
        <WorkShowcase showFilters={false} limit={4} />
      </div>
    </section>
  );
}
